export class mPaswoord {
    public Email: string = "";
    public isNL: boolean=true;
    constructor() { }
}
